// extracted by mini-css-extract-plugin
module.exports =  {"actionFooter":"actionFooter__MK3pO","saveAsDraftBtn":"saveAsDraftBtn__AXAAi","tip":"tip__6FOcA"};